import { render } from "./AMSConfigurator.vue?vue&type=template&id=43870b0e&scoped=true&ts=true"
import script from "./AMSConfigurator.vue?vue&type=script&lang=ts"
export * from "./AMSConfigurator.vue?vue&type=script&lang=ts"

import "./AMSConfigurator.vue?vue&type=style&index=0&id=43870b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43870b0e"]])

export default __exports__